module.exports = __webpack_public_path__ + "static/media/car1.55bab457.png";